
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-800 border-t border-gray-700 text-gray-400 py-8 mt-auto z-10 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-sm">
                {/* Brand Section */}
                <div className="flex flex-col space-y-4">
                    <div className="text-xl font-bold text-white">
                        RaceLine<span className="text-cyan-400">IQ</span>
                    </div>
                    <p className="text-gray-500">
                        Don't just train harder.
                        Race Smarter.
                    </p>
                </div>

                {/* Quick Links */}
                <div className="flex flex-col space-y-3">
                    <h3 className="text-xs font-bold text-white uppercase tracking-wider">Navigation</h3>
                    <Link to="/" className="hover:text-cyan-400 transition-colors">Find Races</Link>
                    <Link to="/races" className="hover:text-cyan-400 transition-colors">Your Races</Link>
                    <Link to="/profile" className="hover:text-cyan-400 transition-colors">Profile</Link>
                    <Link to="/about" className="hover:text-cyan-400 transition-colors">About</Link>
                </div>

                {/* Contact Us */}
                <div className="flex flex-col space-y-3">
                    <h3 className="text-xs font-bold text-white uppercase tracking-wider">Contact Us</h3>
                    <p className="text-gray-400">
                        Have questions or feedback?
                    </p>
                    <a href="mailto:support@racelineiq.com" className="text-cyan-400 hover:text-cyan-300 transition-colors font-medium">
                        support@racelineiq.com
                    </a>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf2uqxc117LRWuX4SQFyVpNfY5SRTNgi9calkfxFIFXqlwR_A/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 transition-colors font-medium">
                        Submit Feedback
                    </a>
                </div>

                {/* Legal & Copyright */}
                <div className="flex flex-col space-y-3">
                    <h3 className="text-xs font-bold text-white uppercase tracking-wider">Legal</h3>
                    <Link to="/terms" className="hover:text-cyan-400 transition-colors">Terms of Service</Link>
                    <Link to="/eula" className="hover:text-cyan-400 transition-colors">EULA</Link>
                    <Link to="/privacy" className="hover:text-cyan-400 transition-colors">Privacy Policy</Link>
                    <div className="mt-4 text-xs text-gray-600">
                        <div>&copy; {currentYear} RaceLineIQ. All rights reserved.</div>
                        <div>RaceLineIQ is a product of Full Spectrum Racing LLC</div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;